<ion-content>
  <ion-list>
    <ion-item class="datePicker">
      <ion-calendar [(ngModel)]="selectedDate" [options]="calendarOptions"
        (monthChange)="monthChange($event)"
        (change)="onDateChange($event)"></ion-calendar>
    </ion-item>
  </ion-list>
</ion-content>
